import { FC, useState, useEffect } from 'react';
import './style.scss';
import { Button, Pagination, Modal } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import { columns, FiledKey } from './data';
import { getByIdCardApi, fileListApi } from '../../api';
const Success: FC<any> = ({ next = () => {}, nextParam = {}, idCard = '' , userInfo ='' , userInfo2 ='',uuid = ''}) => {
    const [data, setData] = useState([]);

    const [downloadData, setDownloadData] = useState([]);

    const [isApplyOpen, setIsApplyOpen] = useState(false);

    const [total, setTotal] = useState(0);

    useEffect(() => {
        update(1);
    }, []);

    async function update(page: number) {
        const { data } = await getByIdCardApi({ idCard: idCard, pageIndex: page,type: "1" ,uuid:uuid});
        if (!data) return;
        setData(data.records || []);
        setTotal(data.total ?? 0);
    }

    function back() {
        next(0);
    }

    async function openApplyModal(params: any) {
        const { data = [] } = await fileListApi({ receiveId: params.receiveId });
        setDownloadData(data.filter((item: any) => item.authorizedMaterialFlag === '0'));
        setIsApplyOpen(true);
    }

    async function openExamineModal(params: any) {
        const { data = [] } = await fileListApi({ receiveId: params.receiveId });
        setDownloadData(data.filter((item: any) => item.authorizedMaterialFlag === '1'));
        setIsApplyOpen(true);
    }

    const handleCancel = () => {
        setIsApplyOpen(false);
    };

    function download(item: any) {
        window.open(item.url);
    }

    return (
        <div className='box success-box'>
            <div className='text-title'>
                <span className='line'></span>
                {nextParam.success ? <span>部门受理信息</span> : <span>提交部门审查状态</span>}
            </div>
            <div className='text-title-line'></div>
            <div>
                {nextParam.success ? (
                    <div>
                        <table className='table table-responsive' align='center'>
                            <tbody>
                                <tr>
                                    {columns.map(({ title, width, filed }) => (
                                        <td className='bl-bg text-tag' width={width} key={filed} >
                                            {title}
                                        </td>
                                    ))}
                                </tr>
                                {data.map((item: any, index) => (
                                    <tr key={index}>
                                        {columns.map(({ filed, format }) =>
                                            filed === FiledKey.INDEX ? (
                                                <td key={filed + index}>{index + 1}</td>
                                            ) : filed === FiledKey.BZ ? (
                                                <td key={filed + index}>
                                                    <Button
                                                        onClick={openApplyModal.bind(null, item)}
                                                        size='small'
                                                        type='primary'
                                                        style={{ background:"gray" }}
                                                    >
                                                        申请材料下载
                                                    </Button>
                                                    <Button
                                                        onClick={openExamineModal.bind(null, item)}
                                                        size='small'
                                                        type='primary'
                                                        disabled={item['status'] !== '2'}
                                                        style={{ marginLeft: '15px' }}
                                                    >
                                                        审查结果材料下载
                                                    </Button>
                                                </td>
                                            ) : filed === FiledKey.STATE ? (
                                                // eslint-disable-next-line eqeqeq
                                                <td key={filed + index} style={{ color: item[filed]=='2'?'green':item[filed]=='3'?'red':'black' }}>
                                                  {format
                                                  
                                                    ? ( 
                                                        format(item[filed]) ?? '--'
                                                        )
                                                        : (item[filed] ?? '--')

                                                  }
                                                </td>
                                            ) : filed === FiledKey.REASON ? (
                                                <td key={filed + index} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                                    {format
                                                        ? format(item[filed]) ?? '--'
                                                        : item[filed] ?? '--'}
                                                </td>
                                            ) : (
                                                <td key={filed + index}>
                                                    {format
                                                        ? format(item[filed]) ?? '--'
                                                        : item[filed] ?? '--'}
                                                </td>
                                            )
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {data.length === 0 ? (
                            <div
                                style={{
                                    textAlign: 'center',
                                    marginBottom: '30px',
                                    fontSize: '18px'
                                }}
                            >
                                暂无数据！
                            </div>
                        ) : null}
                        <div style={{ textAlign: 'right', marginTop: '-15px', padding: '0 35px' }}>
                            <Pagination onChange={(page, pageSize) => update(page)} total={total} />
                        </div>
                        <div style={{ marginTop: '35px' }}>
                            <Button onClick={back} size='large' type='primary'>
                                返回协议确认
                            </Button>
                        </div>
                    </div>
                ) : (
                    <p className='text error'>
                        <CloseCircleOutlined /> 申请失败
                    </p>
                )}
                {/* <p className='text-tips'>可在个人中心查看办理进度和结果</p> */}
            </div>
            <div>
                {nextParam.success ? null : (
                    <Button
                        onClick={next.bind(null, 5)}
                        type='primary'
                        style={{ width: 140, marginTop: 15, height: 35 }}
                    >
                        重新提交申请
                    </Button>
                )}
            </div>
            <Modal
                title='下载申请材料'
                footer={null}
                width={600}
                open={isApplyOpen}
                onCancel={handleCancel}
            >
                <table
                    className='table table-responsive'
                    style={{ margin: 0, width: '100%' }}
                    align='center'
                >
                    <tbody>
                        <tr>
                            <td className='bl-bg text-tag' width='70%'>
                                文件名称
                            </td>
                            <td className='bl-bg text-tag' width='30%'>
                                操 作
                            </td>
                        </tr>
                        {downloadData.map((item: any, index) => (
                            <tr key={index}>
                                <td>{item.fileName}</td>
                                <td>
                                    <Button
                                        onClick={download.bind(null, item)}
                                        size='small'
                                        type='primary'
                                    >
                                        下载
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {downloadData.length === 0 ? (
                    <div
                        style={{
                            textAlign: 'center',
                            marginBottom: '30px',
                            fontSize: '18px'
                        }}
                    >
                        暂无数据！
                    </div>
                ) : null}
            </Modal>
        </div>
    );
};

export default Success;
